import { eventChannel } from "redux-saga";

function workerChannel(worker: Worker) {
  return eventChannel((emitter) => {
    worker.onmessage = (comm) => {
      emitter(comm.data);
    };

    return () => {
      worker.terminate();
    };
  });
}

export default workerChannel;
